import Service from "../../AuthService";
const MachineSheet = {
    getMachineSheet(page) {
        return Service.get("/machine-sheet?page="+page);
    },
    showMachineSheet(id) {
        return Service.get("/machine-sheet/" + id);
    },
    updateMachineSheet(id, data) {
        return Service.put("/machine-sheet/" + id, data);
    },
    createMachineSheet(data) {
        return Service.post("/machine-sheet", data);
    },
    deleteMachineSheet(id) {
        return Service.delete("/machine-sheet/" + id);
    },
};
export default MachineSheet;
